import React, { useContext } from 'react'
import { ExternalLinkIcon, Text } from 'chemistry'
import { AttributeRow } from 'client/fragments/productDetailsFragmentInfo/components/Description/CollapsibleAttributes/AttributeRow'
import { TranslateContext } from 'client/common/translator'

const DocumentAttributeRow = ({ index, displayName, value, documentUrl }) => {
  return (
    <AttributeRow
      index={index}
      displayName={displayName}
      value={
        <>
          {value}
          <a href={documentUrl} target='_blank' rel='noreferrer'>
            <ExternalLinkIcon style={{ width: '16px', color: 'var(--chakra-colors-red-primary)' }} />
          </a>
        </>
      }
    />
  )
}

export const getSafetyDocumentNameBySubType = (subType, t) => {
  if (subType === 'DOP') return t('safety_documents.declaration_of_performance')
  if (subType === 'SDS') return t('safety_documents.safety_data_sheet')
  return ''
}

export const DocumentsList = ({ documents, safetyDocuments }) => {
  const t = useContext(TranslateContext)
  return (
    <div className='attr-section'>
      <dl>
        <Text as='b' mb='4' display='block'>
          {t('cluster_documents')}
        </Text>
        {documents.map((doc, index) => (
          <DocumentAttributeRow
            key={doc.id}
            index={index}
            displayName={doc.subType}
            value={doc.id}
            documentUrl={doc.url}
          />
        ))}
        {safetyDocuments.map((doc, index) => (
          <DocumentAttributeRow
            key={doc.publicUrl}
            index={documents.length + index}
            displayName='PDF'
            value={getSafetyDocumentNameBySubType(doc.subType, t)}
            documentUrl={doc.publicUrl}
          />
        ))}
      </dl>
    </div>
  )
}
